import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Button, Modal, Form } from 'react-bootstrap';
import { useUserAuth } from '../../context/UserAuthContext';

const Calendar = () => {
    const { user, token } = useUserAuth();
    const merchant_id = user.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState('');
    const [status, setStatus] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [events, setEvents] = useState([]);
    console.log('events', events)
    const [color, setColor] = useState('');

    useEffect(() => {
        getAvailabilityData();
    }, [merchant_id]);

    const getAvailabilityData = async () => {
        try {
            const response = await axios.get(`${base_url}/api/v1/availablity/vendor_id/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const formattedEvents = response.data.data.map(event => ({
                ...event,
                start: event.start_date,
                end: event.end_date,
            }));
            setEvents(formattedEvents);
        } catch (error) {
            console.log(`Error ${error}`);
        }
    };


    const handleClose = () => {
        setShow(false);
        setTitle('');
        setStatus('');
        setColor('');
    };

    const handleSelection = (e) => {
        setStartDate(e.startStr);
        setEndDate(e.endStr);
        setShow(true);
    };

    const addEvent = async (e) => {
        e.preventDefault();
        const newEvent = {
            title,
            start: startDate,
            end: endDate,
            color,
            merchant_id,
            paymentStatus: 'pending',
            status
        };
        try {
            const response = await axios.post(`${base_url}/api/v1/availablity`, newEvent, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEvents([...events, newEvent]);
            toast.success('Event Added Successfully');
            handleClose();
        } catch (error) {
            console.error('Failed to create event:', error);
            toast.error('Failed to create event');
        }
    };

    const dropdownHandler = (e) => {
        const cur_status = e.target.value;
        setStatus(cur_status);
        if (cur_status === 'not_available') {
            setColor('#000');
        } else if (cur_status === 'booked') {
            setColor('#df3a42');
        } else if (cur_status === 'blocked') {
            setColor('#fd7d00');
        }
    };

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className='card-header bg-white'>
                                <p><b>Update Your Calendar</b></p>
                            </div>
                            <div className='card-body'>
                                <FullCalendar
                                    plugins={[dayGridPlugin, interactionPlugin]}
                                    initialView='dayGridMonth'
                                    weekends={true}
                                    events={events}
                                    selectable={true}
                                    select={handleSelection}
                                />
                                <Modal show={show} onHide={handleClose}>
                                    <Form onSubmit={addEvent}>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Add Event</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Event Title</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Add Event Title"
                                                    value={title}
                                                    onChange={(e) => setTitle(e.target.value)}
                                                    required
                                                />
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select onChange={dropdownHandler} required>
                                                    <option disabled selected>Choose Status</option>
                                                    <option value="not_available">Not Available</option>
                                                    <option value="booked">Booked</option>
                                                    <option value="blocked">Blocked</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button type="submit" variant="primary">Add Event</Button>
                                        </Modal.Footer>
                                    </Form>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Calendar;